module.exports = __webpack_public_path__ + "media/images/features/support/heading-type-edc0f1badfbf8f0870148019cf843efb.svg";